
import React from 'react';

export const DocumentPlusIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    note_add
  </span>
);